import { SessionData, LicenseType } from '@yaak/components/services/api/api'
import { getDriveType } from '@yaak/admin/src/helpers/devices'
import React, { Dispatch, SetStateAction } from 'react'
import { toastType } from '@yaak/components/src/Toast/Toast'
import Progress from '@yaak/components/src/Progress'
import Icon from '@yaak/components/src/Icon'
import DataStatus from '@yaak/admin/src/components/DataStatus'
import { transpose } from '@yaak/admin/src/helpers/common'
import { IconSizes } from '@yaak/components/src/Icon/Icon'
import { NavigateFunction } from 'react-router-dom'
import {
  formatTimestamp,
  formatTimestampToTime,
  toDurationPrecise,
} from '@yaak/admin/src/helpers/time'
import {
  BitRateGridElement,
  GridCopyIconElement,
  GridDriverElement,
  GridDriveStatusElement,
  GridIconElement,
  GridInstructorElement,
  GridKitElement,
  GridPartnerElement,
  GridTextElement,
  GridVehicleElement,
} from '@yaak/components/src/Grid/GridElements'
import { FormattedMessage } from 'react-intl'
import {getLicenseType} from "@yaak/components/helpers/licenseHelpers"

export const HEADERS = [
  <FormattedMessage key="date_time" id={'date_time'} />,
  <FormattedMessage key="partner" id={'partner'} />,
  <FormattedMessage key="type" id={'type'} />,
  <FormattedMessage key="vehicle" id={'vehicle'} />,
  <FormattedMessage key="kit_id" id={'kit_id'} />,
  <FormattedMessage key="driver" id={'driver'} />,
  <FormattedMessage key="vehicle_type" id={'vehicle_type_header'} />,
  <FormattedMessage key="instructor" id={'instructor'} />,
  <FormattedMessage key="license_class" id={'license_class'} />,
  <FormattedMessage key="status" id={'status'} />,
  <FormattedMessage key="data" id={'data'} />,
  <FormattedMessage key="bitrate" id={'bitrate'} />,
  '',
]

const DSADMIN_HEADERS = [
  <FormattedMessage key="date_time" id={'date_time'} />,
  <FormattedMessage key="type" id={'type'} />,
  <FormattedMessage key="vehicle" id={'vehicle'} />,
  <FormattedMessage key="vehicle_type" id={'vehicle_type_header'} />,
  <FormattedMessage key="driver" id={'driver'} />,
  <FormattedMessage key="license_class" id={'license_class'} />,
  <FormattedMessage key="data" id={'data'} />
]

const DSADMIN_HEADERS_STUDENTS = [
  <FormattedMessage key="date_time" id={'date_time'} />,
  <FormattedMessage key="type" id={'type'} />,
  <FormattedMessage key="vehicle" id={'vehicle'} />,
  <FormattedMessage key="vehicle_type" id={'vehicle_type_header'} />,
  <FormattedMessage key="license_class" id={'license_class'} />,
  <FormattedMessage key="data" id={'data'} />
]

const DSADMIN_HEADERS_VEHICLES = [
  <FormattedMessage key="date_time" id={'date_time'} />,
  <FormattedMessage key="type" id={'type'} />,
  <FormattedMessage key="driver" id={'driver'} />,
  <FormattedMessage key="vehicle_type" id={'vehicle_type_header'} />,
  <FormattedMessage key="instructor" id={'instructor'} />,
  <FormattedMessage key="license_class" id={'license_class'} />,
  <FormattedMessage key="data" id={'data'} />,
]
export const NUTRON_HEADERS = [
  'Drive ID',
  'Incidents',
  'Map features',
  'Type',
  'Driver',
  'Lighting',
  'Weather',
  'Start',
  'End',
  'Duration',
  'Kit ID',
  'Data',
  '',
]

export type statusDataType = {
  metadataStatus?: number
  fullVideoStatus?: number
  videoStatus?: number
}

type resultType = {
  value: number
  data: statusDataType
}

interface MappedDrivesTypeOptions {
  withPartner: boolean
  withInstructor: boolean
  withKit: boolean
  dsAdmin: boolean
  withDriver: boolean
  withVehicle: boolean
  fixedColumns: number
  nutron: boolean
  withVehicleName: boolean
}

export const getDataComponent = (result: resultType, dsAdmin = false) => {
  return result.value === 10
    ? {
      text: (
        <DataStatus
          icon={<Progress percentage={result.value} />}
          data={result.data}
          type={2}
          dsAdmin={dsAdmin}
        />
      ),
      popover: true,
    }
    : result.value === 33
      ? {
        text: (
          <DataStatus
            icon={<Progress percentage={result.value} />}
            data={result.data}
            type={2}
            dsAdmin={dsAdmin}
          />
        ),
        popover: true,
      }
      : result.value === 67
        ? {
          text: (
            <DataStatus
              icon={<Progress percentage={result.value} />}
              data={result.data}
              type={2}
              dsAdmin={dsAdmin}
            />
          ),
          popover: true,
        }
        : result.value === 1
          ? {
            text: (
              <DataStatus
                icon={<Icon name={'Success'} size={IconSizes.medium} />}
                data={result.data}
                type={3}
                dsAdmin={dsAdmin}
              />
            ),
            popover: true,
          }
          : result.value === -1
            ? {
              text: (
                <DataStatus
                  icon={<Icon name={'Error'} />}
                  data={result.data}
                  type={4}
                  dsAdmin={dsAdmin}
                />
              ),
              popover: true,
            }
            : result.value === 0
              ? {
                text: (
                  <DataStatus
                    icon={<Progress />}
                    data={result.data}
                    type={result.value}
                    dsAdmin={dsAdmin}
                  />
                ),
                popover: true,
              }
              : null
}

export const getSessionStatus = (data: statusDataType) => {
  const { metadataStatus, fullVideoStatus, videoStatus } = data
  return ((metadataStatus === undefined || metadataStatus === null) &&
    fullVideoStatus === 2 &&
    videoStatus === 3) ||
  ((metadataStatus === undefined || metadataStatus === null) &&
    fullVideoStatus === 3 &&
    videoStatus === 2) ||
  (metadataStatus === 2 &&
    (fullVideoStatus === undefined || fullVideoStatus === null) &&
    videoStatus === 3) ||
  (metadataStatus === 3 &&
    (fullVideoStatus === undefined || fullVideoStatus === null) &&
    videoStatus === 2) ||
  (metadataStatus === 2 &&
    fullVideoStatus === 3 &&
    (videoStatus === undefined || videoStatus === null)) ||
  (metadataStatus === 3 &&
    fullVideoStatus === 2 &&
    (videoStatus === undefined || videoStatus === null))
    ? {
      value: 10,
      data: {
        metadataStatus,
        fullVideoStatus,
        videoStatus,
      },
    }
    : (metadataStatus === 3 && fullVideoStatus === 2 && videoStatus === 0) ||
    (metadataStatus === 3 && fullVideoStatus === 0 && videoStatus === 2) ||
    (metadataStatus === 2 && fullVideoStatus === 3 && videoStatus === 0) ||
    (metadataStatus === 0 && fullVideoStatus === 3 && videoStatus === 2) ||
    (metadataStatus === 2 && fullVideoStatus === 0 && videoStatus === 3) ||
    (metadataStatus === 0 && fullVideoStatus === 2 && videoStatus === 3) ||
    (metadataStatus === 3 && fullVideoStatus === 4 && videoStatus === 0) ||
    (metadataStatus === 3 && fullVideoStatus === 0 && videoStatus === 4) ||
    (metadataStatus === 4 && fullVideoStatus === 3 && videoStatus === 0) ||
    (metadataStatus === 0 && fullVideoStatus === 3 && videoStatus === 4) ||
    (metadataStatus === 4 && fullVideoStatus === 0 && videoStatus === 3) ||
    (metadataStatus === 0 && fullVideoStatus === 4 && videoStatus === 3)
      ? {
        value: 33,
        data: {
          metadataStatus,
          fullVideoStatus,
          videoStatus,
        },
      }
      : (metadataStatus === 3 && fullVideoStatus === 3 && videoStatus === 2) ||
      (metadataStatus === 3 && fullVideoStatus === 2 && videoStatus === 3) ||
      (metadataStatus === 2 && fullVideoStatus === 3 && videoStatus === 3)
        ? {
          value: 67,
          data: {
            metadataStatus,
            fullVideoStatus,
            videoStatus,
          },
        }
        : metadataStatus === 3 && fullVideoStatus === 3 && videoStatus === 3
          ? {
            value: 1,
            data: {
              metadataStatus,
              fullVideoStatus,
              videoStatus,
            },
          }
          : metadataStatus === 4 || fullVideoStatus === 4 || videoStatus === 4
            ? {
              value: -1,
              data: {
                metadataStatus,
                fullVideoStatus,
                videoStatus,
              },
            }
            : {
              value: 0,
              data: {
                metadataStatus,
                fullVideoStatus,
                videoStatus,
              },
            }
}

const getRows = (
  data: SessionData[],
  activeDrivesIds: string[],
  setShowToast: Dispatch<SetStateAction<toastType | null>>,
  navigate: NavigateFunction,
  matches: boolean,
  options: MappedDrivesTypeOptions,
  licenseTypes: LicenseType[],
  locale: string
) => {
  return data.map((session: SessionData) => {
    const row = []
    row.push(
      GridTextElement({
        text: formatTimestamp(session.startTimestamp, locale),
        ellipsis: matches,
      })
    )
    options?.withPartner &&
    row.push(
      GridPartnerElement({
        partner: session.partner,
        ellipsis: true,
        navigate,
      })
    )
    row.push(
      GridTextElement({
        ellipsis: matches,
        text: getDriveType(session.driveType),
      })
    )
    options?.withVehicle &&
    row.push(
      GridVehicleElement({
        vin: session.vin,
        dongleId: session.dongleId,
        ellipsis: matches,
        navigate,
        dsAdmin: options?.dsAdmin,
      })
    )
    options?.withVehicleName &&
    row.push(
      GridTextElement({
        text: session.vehicleTypeName != null ? session.vehicleTypeName : '-',
      })
    )
    options?.withKit &&
    row.push(
      GridKitElement({
        id: session.dongleId,
        ellipsis: matches,
        navigate,
      })
    )
    options?.withDriver &&
    row.push(
      GridDriverElement({
        driver: session.driver,
        ellipsis: matches,
        navigate,
        dsAdmin: options.dsAdmin,
      })
    )
    options?.withInstructor &&
    row.push(
      GridInstructorElement({
        session,
        ellipsis: matches,
        navigate,
        dsAdmin: options.dsAdmin,
      })
    )
    row.push(
      GridTextElement({
        text: getLicenseType(session.licenseId, licenseTypes),
        ellipsis: matches,
      })
    )
    !options?.dsAdmin &&
    row.push(
      GridDriveStatusElement({
        session,
        activeDrivesIds,
      })
    )
    row.push(
      getDataComponent(
        getSessionStatus({
          metadataStatus: session.metadataStatus,
          fullVideoStatus: session.fullVideoStatus,
          videoStatus: session.videoStatus,
        }),
        options?.dsAdmin
      )
    )
    !options?.dsAdmin &&
    row.push(
      BitRateGridElement({
        session,
      })
    )
    !options?.dsAdmin &&
    row.push(
      GridCopyIconElement({
        data: session,
        name: 'drive',
        setShowToast,
        text: 'Drive ID copied to clipboard',
      })
    )
    return row
  })
}

const getRowsNutron = (
  data: SessionData[],
  activeDrivesIds: string[],
  setShowToast: Dispatch<SetStateAction<toastType | null>>,
  navigate: NavigateFunction,
  matches: boolean,
  locale: string
) => {
  return data.map((session: SessionData) => {
    const row = []

    row.push(
      GridTextElement({
        text: session.canonicalName,
        ellipsis: matches,
      })
    )

    row.push(
      GridIconElement({
        text: session.incidentCount.toString(),
      })
    )
    row.push(
      GridIconElement({
        text: session.curriculumCount.toString(),
      })
    )
    row.push(
      GridTextElement({
        ellipsis: matches,
        text: getDriveType(session.driveType),
      })
    )
    row.push(
      GridDriverElement({
        driver: session.driver,
        ellipsis: matches,
        navigate,
      })
    )
    row.push(
      GridTextElement({
        text: session.lightningConditions.join(', ') || '-',
        ellipsis: true,
      })
    )
    row.push(
      GridTextElement({
        text: session.weatherConditions.join(', ') || '-',
        ellipsis: true,
      })
    )
    row.push(
      GridTextElement({
        text: formatTimestampToTime(session.startTimestamp, locale),
        ellipsis: matches,
      })
    )
    row.push(
      GridTextElement({
        text: formatTimestampToTime(session.endTimestamp, locale),
        ellipsis: matches,
      })
    )
    row.push(
      GridIconElement({
        text: toDurationPrecise(session.startTimestamp, session.endTimestamp),
      })
    )
    row.push(
      GridTextElement({
        text: session.dongleId,
        ellipsis: matches,
      })
    )
    row.push(
      getDataComponent(
        getSessionStatus({
          metadataStatus: session.metadataStatus,
          fullVideoStatus: session.fullVideoStatus,
          videoStatus: session.videoStatus,
        })
      )
    )
    row.push(
      GridCopyIconElement({
        data: session,
        name: 'drive',
        setShowToast,
        text: 'Drive ID copied to clipboard',
      })
    )
    return row
  })
}

interface MappedDrivesType {
  sessionsData: SessionData[]
  activeSessionsData: SessionData[]
  setShowToast: Dispatch<SetStateAction<toastType | null>>
  totalCount?: number
  matches: boolean
  classes?: any
  options?: MappedDrivesTypeOptions
  navigate: NavigateFunction
  licenseTypes: LicenseType[]
}

const getHeaders = (options?: MappedDrivesTypeOptions) => {
  let headers = HEADERS
  if (options?.nutron) {
    headers = NUTRON_HEADERS
  } else if (options?.dsAdmin) {
    headers = !options?.withVehicle
      ? DSADMIN_HEADERS_VEHICLES
      : options?.withDriver
        ? DSADMIN_HEADERS
        : DSADMIN_HEADERS_STUDENTS
  } else if (
    !options?.withPartner &&
    !options?.withInstructor &&
    !options?.withKit
  ) {
    headers = HEADERS.filter((header, idx) => idx !== 1)
      .filter((header, idx) => idx !== 5)
      .filter((header, idx) => idx !== 3)
  } else if (!options?.withPartner) {
    headers = HEADERS.filter((header, idx) => idx !== 1)
  } else if (!options?.withInstructor) {
    headers = HEADERS.filter((header, idx) => idx !== 6)
  } else if (!options?.withKit) {
    headers = HEADERS.filter((header, idx) => idx !== 4)
  }
  return headers
}

export const getMappedDrives = ({
                                  sessionsData,
                                  activeSessionsData = [],
                                  setShowToast,
                                  totalCount,
                                  matches,
                                  options = {
                                    withPartner: true,
                                    withInstructor: true,
                                    withKit: true,
                                    dsAdmin: false,
                                    withDriver: true,
                                    withVehicle: true,
                                    withVehicleName: true,
                                    fixedColumns: 0,
                                    nutron: false,
                                  },
                                  navigate,
                                  licenseTypes,

                                }: MappedDrivesType, locale: string) => {
  const activeDrivesIds = activeSessionsData.map(
    (activeSession) => activeSession.id
  )

  const ids = activeSessionsData
    .concat(sessionsData)
    .map((session) => session.id)

  const columns = transpose(
    options.nutron
      ? getRowsNutron(
        sessionsData,
        activeDrivesIds,
        setShowToast,
        navigate,
        matches,
        locale
      )
      : getRows(
        sessionsData,
        activeDrivesIds,
        setShowToast,
        navigate,
        matches,
        options,
        licenseTypes,
        locale
      )
  )

  columns.map((row: any, i: number) =>
    getHeaders(options).map((header, k) => i === k && row.unshift(header))
  )

  return {
    options: {
      fixedColumns: options?.fixedColumns || 4,
      activeDrivesIds,
      active: activeDrivesIds.map((id) => ids.indexOf(id)),
      totalCount,
    },
    rows: columns,
  }
}
